"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactInterpolatePlugin = _interopRequireDefault(require("react-interpolate-plugin"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(options, instance) {
  instance.interpolate = function interpolateExtended(key, params) {
    return instance.getValue(key, params, _reactInterpolatePlugin["default"]);
  };
};

exports["default"] = _default;